export const isValidIdentifier = (value: unknown): boolean => {
  if (value === null || value === undefined) return false;

  const str = String(value).trim();

  if (str.length === 0) return false;

  const num = Number(str);

  if (!isNaN(num)) {
    return num > 0;
  }
  return true;
};
